import { OverrideCustomElementConfig } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { Event, EventHandler, NoBubblesEventInit } from "@cervval.js/client-html5-core/src/components/event.decorator";
import { TypedWebComponentOptions, WebComponentOptions } from "@cervval.js/client-html5-core/src/components/typedWebComponentOptions.decorator";
import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";
import { toggleAttribute } from "@cervval.js/client-html5-core/src/tools/dom.tools";
import { ValueOrFunction, getVOFValue } from "@cervval.js/common/src/tools/object.tools";
import { anyReallyAny } from "@cervval.js/common/tools";


/** Parameters options for pickers */
export interface PickerOptions {

    /** Disable state of picker */
    disabled: ValueOrFunction<boolean>;
}


/** Event triggered with value of picker has change */
export type OnPickerValueChangeEvent<ValueType> = {

    /** New value of picker */
    value: ValueType
}


export abstract class Picker<ValueType, I18n = unknown> extends WebComponent<I18n> {

    // !Important to set bubbles to false to avoid event propagation in DOM
    @Event(NoBubblesEventInit)
    public valueChangeEvent!: EventHandler<{ value: ValueType }>;

    @TypedWebComponentOptions()
    public readonly options!: WebComponentOptions<PickerOptions>;

    /** Value of picker */
    protected _value: ValueType | undefined = undefined;

    /** @returns true if picker is disabled */
    public get disabled(): boolean {
        return Boolean(getVOFValue(this.options.disabled));
    }

    constructor(customElementOptions?: OverrideCustomElementConfig) {
        super(customElementOptions);
        this.classList.add("picker");
    }

    /** On picker refresh */
    public override refresh(): void {
        super.refresh();
        this.refreshDisabled();
    }

    /** Picker value getter */
    public getValue(): ValueType | undefined {
        return this._value;
    }

    /** Picker value setter */
    public setValue(value: ValueType | undefined): void {
        this._value = value;
    }

    /** Dispatch value change in picker */
    protected _dispatchOnPickerValueChange(value?: ValueType | anyReallyAny): void {
        if (this.disabled) { return; }// Don't dispatch value change event if picker is disabled
        this.valueChangeEvent.emit({ value: value ?? this._value });
    }

    /** Update disabled state on picker */
    public refreshDisabled(): void {
        this.toggleDisabledAttribute();
    }

    /** Update disable attribute on picker */
    public toggleDisabledAttribute(): void {
        toggleAttribute(this, this.disabled, "disabled", "");
    }
}